import { Easing, Tween } from '@tweenjs/tween.js';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import AnimateEntrance from '../helper/animate';
import { getCurrencySymbol } from '../helper/currencies';
import { EVENTS } from '../../lib/constants';

class FreespinStatusbarController {
	constructor(vc, conf) {
		this.config = conf;
		this.vc = vc;

		AnimateEntrance(this.vc);
		this.LEFT_BETS_TEXT = this.vc.getChildByName('FREE_SPIN_LEFT_AMOUNT', true);
		this.WIN_TEXT = this.vc.getChildByName('FREE_SPIN_WIN_AMOUNT', true);
		this.totalWin = GameConfigs.freeSpinLocal.totalWin
			? GameConfigs.freeSpinLocal.totalWin
			: 0;
		this.win = this.totalWin;
		this.curr = GameConfigs.freeSpin.currency;
		this.curr = 'USD';
		this.currency = getCurrencySymbol(this.curr);
		this.addEventListeners();
		this.init();
	}

	handleEvent(evt) {
		switch (evt.type) {
			case EVENTS.ERROR_MSG:
				this.updateWin(this.totalWin);
				break;
			case EVENTS.REEL_FINISHED:
				this.updateWin(this.totalWin);
				break;
			case EVENTS.SERVER_MSG:
				if (evt.detail.service === 'freespinstep') {
					this.LEFT_BETS_TEXT.text = evt.detail.data.free_spin_step.count;
					this.totalWin = evt.detail.data.free_spin_step.total_win;
					if (evt.detail.data.free_spin_step.status === 'completed') {
						this.removeEventListeners();
					}
				}
				break;
			default:
				break;
		}
	}

	addEventListeners() {
		window.addEventListener(EVENTS.REEL_FINISHED, this, false);
		window.addEventListener(EVENTS.SERVER_MSG, this, false);
		window.addEventListener(EVENTS.ERROR_MSG, this, false);
	}

	removeEventListeners() {
		window.removeEventListener(EVENTS.REEL_FINISHED, this, false);
		window.removeEventListener(EVENTS.SERVER_MSG, this, false);
		window.removeEventListener(EVENTS.ERROR_MSG, this, false);
	}

	init() {
		this.LEFT_BETS_TEXT.text = GameConfigs.freeSpinLocal.count;
		this.setWin();
	}

	setWin() {
		if (this.currency[1] === 'left') {
			this.WIN_TEXT.text =
				this.currency[0] +
				(+this.win).toLocaleString(undefined, {
					minimumFractionDigits: GameConfigs.config.currency_prec,
					maximumFractionDigits: GameConfigs.config.currency_prec
				});
		} else {
			this.WIN_TEXT.text =
				(+this.win).toLocaleString(undefined, {
					minimumFractionDigits: GameConfigs.config.currency_prec,
					maximumFractionDigits: GameConfigs.config.currency_prec
				}) +
				(this.curr === 'GEL' ? '' : ' ') +
				this.currency[0];
		}
	}

	update(obj) {
		this.LEFT_BETS_TEXT.text = obj.text;
	}

	updateWin(win) {
		this.tweener = new Tween(this)
			.to({ win: win }, 500)
			.easing(Easing.Linear.None)
			.onUpdate(() => {
				this.setWin();
			})
			.start();
	}
}
export default FreespinStatusbarController;
